import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { pb } from '@/core/api';
import { useRegistrationFlow } from './use-registration-flow';

type Step = 'result' | 'signup';

type ResultState = { passed?: boolean; retryAt?: string };

type Ctx = { hasToken: boolean; hasResult: boolean; hasState: boolean };

function hasResultState(state: unknown): boolean {
  if (!state || typeof state !== 'object') return false;
  const s = state as ResultState;
  return typeof s.passed === 'boolean' || !!s.retryAt;
}

function getRedirect(step: Step, ctx: Ctx): string | null {
  if (step === 'result' && !ctx.hasToken && !ctx.hasState)
    return '/register/test';
  if (step === 'signup' && !ctx.hasToken) return '/register/test';
  if (step === 'signup' && !ctx.hasResult) return '/register/test';
  return null;
}

export function useRequireStep(step: Step): void {
  const nav = useNavigate();
  const location = useLocation();
  const { getSessionToken, hasResultPassed } = useRegistrationFlow();

  useEffect(() => {
    if (pb.authStore.isValid) {
      nav('/creators', { replace: true });
      return;
    }
    const dest = getRedirect(step, {
      hasToken: !!getSessionToken(),
      hasResult: hasResultPassed(),
      hasState: hasResultState(location.state),
    });
    if (dest) nav(dest, { replace: true });
  }, [step, nav, getSessionToken, hasResultPassed, location.state]);
}
